module.exports = __webpack_public_path__ + "img/business_19.bc6ee1ee.jpg";